// Saving appointments. Booking one for a care-plan item (say the 2nd
// vaccination) moves that item's due date to the appointment's day, so the
// plan, the calendar and the reminders all agree.

import { toISODate } from '../domain/time.ts';
import type { Appointment } from '../domain/types.ts';
import { data } from './index.ts';

export function saveAppointment(a: Appointment, previous?: Appointment): void {
  const { store } = data();
  const day = toISODate(a.at);
  const movedFrom = { ...(previous?.movedFrom ?? a.movedFrom ?? {}) };
  // Items no longer on this appointment go back to where they were.
  for (const id of previous?.careIds ?? []) if (!(a.careIds ?? []).includes(id)) restore(id, previous!, movedFrom);
  if (!a.cancelled)
    for (const id of a.careIds ?? []) {
      const c = store.get('care', id);
      if (!c || c.done || c.due === day) continue;
      if (!(id in movedFrom)) movedFrom[id] = c.due ?? null;
      store.put('care', { ...c, due: day, edited: true });
    }
  store.put('appointments', { ...a, movedFrom: Object.keys(movedFrom).length ? movedFrom : undefined });
}

/** Put a care item's date back to before this appointment moved it (if nothing else has changed it since). */
function restore(id: string, a: Appointment, movedFrom: Record<string, string | null>): void {
  const { store } = data();
  const c = store.get('care', id);
  if (c && !c.done && id in movedFrom && c.due === toISODate(a.at)) store.put('care', { ...c, due: movedFrom[id] ?? undefined });
  delete movedFrom[id];
}

export function cancelAppointment(a: Appointment): void {
  const movedFrom = { ...(a.movedFrom ?? {}) };
  for (const id of a.careIds ?? []) restore(id, a, movedFrom);
  data().store.put('appointments', { ...a, cancelled: true, movedFrom: undefined });
}

export function deleteAppointment(a: Appointment): void {
  if (!a.cancelled) {
    const movedFrom = { ...(a.movedFrom ?? {}) };
    for (const id of a.careIds ?? []) restore(id, a, movedFrom);
  }
  data().store.remove('appointments', a.id);
}

/** "No notes needed" for a finished vet appointment. */
export function skipWriteUp(a: Appointment): void {
  data().store.put('appointments', { ...a, noWriteUp: true });
}
